import api from "./api";
import {UpdatePasswordCommand, User} from "@/interfaces/users";

const resource = "/api/data/users";


export const loadWhoAmIData = () => api.get('/whoami')

export const loadMyUser = (username: string) => {
    username = username.replace('+', '%2B');
    return api.get(`${resource}/search/findByUsername?username=${username}`)
}

export const editMyUser = (href: string, user: User) => api.put(href, user)

export const updateMyUserPassword = (data: UpdatePasswordCommand) => api.post('/update-password', data)

